export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = (state) => {
  try {
    localStorage.setItem('state', undefined)
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (err) {
    console.log(err)
  }
}

export const purgeState = () => {
  try {
    localStorage.setItem('state', undefined)
  } catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js